import { Component, OnInit, Inject, ChangeDetectorRef, HostListener } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, AbstractControl } from '@angular/forms';
import { NextComponentService } from '../../../../../lib/services/next-component.service';
import { IComponentDetails } from '../../../../../../src/lib/interfaces/component-details.interface';
import { StepComponent } from '../stepcomponent.class';
import { ComponentName } from '../../../../../lib/enum/component-name.enum';
import { ComponentGroup } from '../../../../../lib/enum/component-group.enum';
import { EmploymentInfoComponent } from '../employment-info/employment-info.component';
import { IZipCodeRequest } from '../../../../../../src/lib/interfaces/IZipCode.interface';
import { CreditAppService } from '../../../../services/credit-app.service';
import { PreviousComponentService } from '../../../../../lib/services/previous-component.service';
import {
  PreviousResidenceInfo,
  CreditApplicationConfig,
  LookupMappingInformation
} from '../../../../../lib/interfaces/credit-application-config.interface';
import { IDescriptionValuePair, IConfig } from '../../../../../lib/interfaces/config.interface';
import { StepType } from '../../../../enum/step-type.enum';
import { getLookupMappings, validateBothNotZero, validateAllFormFields, getBackButton } from '../../../../utils/utils.functions';
import { NotificationsService } from '../../../../../lib/services/notifications.service';
import { NotificationType, INotification } from '../../../../../lib/interfaces/notification.interface';
import { CurrentAddress } from '../../../../interfaces/credit-application.interface';
import { AnalyticsEventService } from '../../../../../lib/services/analytics-event.service';
import { NextCTAClick, ServerError } from '../../../../../lib/actions/analytics.action';
import { IAnalyticsErrorResponse } from '../../../../../lib/interfaces/analytics.interface';
import { UDOConstant, ErrorType } from '../../../../../lib/enum/analytics.enum';
import { BingMapsService } from '../../../../services/bing-maps.service';
import { HeapIoService } from '../../../../services/heap-io.service';

@Component({
  selector: 'dt-previous-residence-info',
  templateUrl: './previous-residence-info.component.html',
  styleUrls: ['./previous-residence-info.component.scss'],
  standalone: false
})
export class PreviousResidenceInfoComponent implements OnInit {
  type: StepType = StepType.Buyer;
  previousResidenceInfoForm: UntypedFormGroup;
  previousZipCodeMask: Array<string | RegExp>;
  prevResidenceInfoConfigData: PreviousResidenceInfo;
  creditAppConfigData: CreditApplicationConfig;
  lookupMappingInfo: LookupMappingInformation[];
  residenceTypes: IDescriptionValuePair[];
  states: IDescriptionValuePair[];
  totalYearsAtAddress: IDescriptionValuePair[];
  totalMonthsAtAddress: IDescriptionValuePair[];
  namePattern: string;
  wordOnlyRegexp: string;
  formSubmitted = false;
  isSaving = false;
  isBuyNow: boolean;
  mapReady = false;
  Microsoft: any;
  SubPage = '';
  isLegacyCreditApp:boolean = false;

  public get previousAddress(): CurrentAddress {
    return (this.creditAppService &&
      this.creditAppService.CreditApplication[this.type] &&
      this.creditAppService.CreditApplication[this.type].personalInformation &&
      Array.isArray(this.creditAppService.CreditApplication[this.type].personalInformation.previousAddress) &&
      this.creditAppService.CreditApplication[this.type].personalInformation.previousAddress[0]) || {};
  }

  // tslint:disable-next-line: variable-name
  private _formSubmitAttempt: boolean;
  public get formSubmitAttempt(): boolean {
    return this._formSubmitAttempt;
  }
  public set formSubmitAttempt(value: boolean) {
    this._formSubmitAttempt = value;
  }

  // tslint:disable-next-line: variable-name
  private _previousAddress1Cleared = true;
  public get previousAddress1Cleared(): boolean {
    return this._previousAddress1Cleared;
  }
  public set previousAddress1Cleared(value: boolean) {
    this._previousAddress1Cleared = value;
  }

  // tslint:disable-next-line: variable-name
  private _previousAddress2Cleared = true;
  public get previousAddress2Cleared(): boolean {
    return this._previousAddress2Cleared;
  }
  public set previousAddress2Cleared(value: boolean) {
    this._previousAddress2Cleared = value;
  }

  // tslint:disable-next-line: variable-name
  private _previousZipCodeCleared = true;
  public get previousZipCodeCleared(): boolean {
    return this._previousZipCodeCleared;
  }
  public set previousZipCodeCleared(value: boolean) {
    this._previousZipCodeCleared = value;
  }

  // tslint:disable-next-line: variable-name
  private _previousCityCleared = true;
  public get previousCityCleared(): boolean {
    return this._previousCityCleared;
  }
  public set previousCityCleared(value: boolean) {
    this._previousCityCleared = value;
  }

  constructor(private fb: UntypedFormBuilder,
    @Inject('config') public SitecoreConfig: IConfig,
    private nextComponentService: NextComponentService,
    private creditAppService: CreditAppService,
    private previousComponentService: PreviousComponentService,
    private notificationService: NotificationsService,
    private analyticsEventService: AnalyticsEventService,
    private cd: ChangeDetectorRef,
    private readonly heapIoService: HeapIoService) { }

  ngOnInit() {

    this.previousZipCodeMask = [/\d/, /\d/, /\d/, /\d/, /\d/];
    this.namePattern = '^[A-Za-z\\s]';
    this.wordOnlyRegexp = '[\\w\\s-,\\.#&\\(\\)\\+\'"]';

    if (
      this.SitecoreConfig &&
      this.SitecoreConfig.Sitecore &&
      this.SitecoreConfig.Sitecore.CreditApplicationConfig
    ) {
      this.isBuyNow = this.SitecoreConfig.Sitecore.isBuyNow;
      this.prevResidenceInfoConfigData = this.SitecoreConfig.Sitecore.CreditApplicationConfig.PreviousResidenceInfo;
      this.creditAppConfigData = this.SitecoreConfig.Sitecore.CreditApplicationConfig;
      this.lookupMappingInfo = this.SitecoreConfig.Sitecore.LookupMappingInformation;
      this.SubPage = this.SitecoreConfig.Sitecore.SubPage ? this.SitecoreConfig.Sitecore.SubPage : '';
      this.isLegacyCreditApp = this.SitecoreConfig.Sitecore.isLegacyCreditApp;
      if(this.isLegacyCreditApp){
        this.updateCtas();
      }
    }

    this.states = getLookupMappings(this.lookupMappingInfo, 'StateCodeType');
    this.totalYearsAtAddress = getLookupMappings(this.lookupMappingInfo, 'YearsAtAddressType');
    this.totalMonthsAtAddress = getLookupMappings(this.lookupMappingInfo, 'MonthsAtAddressType');

    this.previousResidenceInfoForm = this.fb.group({
      PreviousAddress1: [this.previousAddress.addressLine1,
      [Validators.required, Validators.pattern(this.wordOnlyRegexp + '{0,40}')]
      ],
      PreviousAddress2: [this.previousAddress.addressLine2, [Validators.pattern(this.wordOnlyRegexp + '{0,40}')]
      ],
      PreviousZipcode: [this.previousAddress.postalCode,
      [Validators.required, Validators.minLength(5)]
      ],
      PreviousCity: [this.previousAddress.city, [Validators.required, Validators.pattern(this.namePattern + '{0,30}')]],
      PreviousState: [this.previousAddress.stateCode || '', [Validators.required]],
      prevResidenceDurationGroup: this.fb.group({
        PreviousYearsAtAddress: [this.previousAddress.yearsAtAddress || '', [Validators.required]],
        PreviousMonthsAtAddress: [this.previousAddress.monthsAtAddress || '', [Validators.required]]
      }, { validator: validateBothNotZero })
    });

    this.previousResidenceInfoForm.get('PreviousZipcode').valueChanges.subscribe(async(value) => {
      if (
        value !== undefined &&
        value !== null &&
        value.toString().length === 5
      ) {
        const request: IZipCodeRequest = {
          zipCode: value
        };

        const zipCodeResponse = await this.creditAppService.getZipCodeInfo(request);
        

        if (zipCodeResponse && zipCodeResponse.Success) {
          this.previousResidenceInfoForm.patchValue({
            PreviousCity: zipCodeResponse.ZipCodeData.City,
            PreviousState: zipCodeResponse.ZipCodeData.StateCode
          });
        } else if (zipCodeResponse && !zipCodeResponse.Success) {
          if (
            zipCodeResponse.ErrorCodes &&
            zipCodeResponse.ErrorCodes.length > 0
          ) {
            this.previousResidenceInfoForm.patchValue({
              City: '',
              State: ''
            });
            this.previousResidenceInfoForm
              .get('PreviousZipcode')
              .setErrors({ invalidZipCode: true });
          }
        }


      }
    });





    this.notificationService.notificationBroadcasted$.subscribe((n: INotification) => {
      if (n !== null
        && n.Type === NotificationType.clearPreviousResidence
        && n.Payload === this.type) {
        this.resetForm(this.previousResidenceInfoForm);
      }
    });

    if (this.previousResidenceInfoForm.valid) {
      this.formSubmitted = true;
      this.previousResidenceInfoForm.markAsPristine();
    }

    validateAllFormFields(this.previousResidenceInfoForm);

    if (this.type === StepType.CoBuyer) {
      this.notificationService.notificationBroadcasted$.subscribe((n: INotification) => {
        if (n !== null && n.Type === NotificationType.coBuyerDeactivation) {
          this.previousResidenceInfoForm.markAsDirty();
        }
      });
    }

    if (this.SitecoreConfig && this.SitecoreConfig.Sitecore && this.SitecoreConfig.Sitecore.IsAzureMapsEnabled) {
      const coordinates = this.SitecoreConfig.Sitecore.UserPreferredCoordinates;
      const addrElem = document.getElementById('previous_address1');
      addrElem.classList.add('azure-maps-auto-suggest');
      (window as any)
        .AzureMapsLoaded({
          container: 'azure-maps-auto-suggest', latitude: coordinates.Latitude,
          longitude: coordinates.Longitude, address: 'previous_address1', city: 'previous_city',
          state: 'previous_state', zip: 'previous_zip_code', cfrom: 'prequal'
        });
    } else {
      /* istanbul ignore next */
      if (this.SitecoreConfig && this.SitecoreConfig.Sitecore && this.SitecoreConfig.Sitecore.BingKey) {
        BingMapsService.load()
          .then(res => {
            this.mapReady = true;
          }).then(() => {
            setTimeout(() => {
              /* istanbul ignore else */
              if (this.mapReady && typeof Microsoft !== 'undefined') {
                this.loadMap();
              }
            }, 1);
          });
      }
    }
    if(this.isBuyNow){
      if(this.type === StepType.Buyer){
        this.heapIoService.trackPageview('credit-application/previous-residence');        
      }
      else if(this.type === StepType.CoBuyer){
        this.heapIoService.trackPageview('credit-application/cobuyer-previous-residence');        
      }

    }
  }

  loadMap() {
    Microsoft.Maps.loadModule('Microsoft.Maps.AutoSuggest', {
      callback: this.onLoadBingMaps.bind(this),
      errorCallback: this.onErrorBingMaps.bind(this),
      credentials: this.SitecoreConfig.Sitecore.BingKey
    });
  }

  /* istanbul ignore next */
  onLoadBingMaps() {
    let options: any;
    if (this.SitecoreConfig && this.SitecoreConfig.Sitecore && this.SitecoreConfig.Sitecore.UserPreferredCoordinates !== undefined) {
      const coordinates = this.SitecoreConfig.Sitecore.UserPreferredCoordinates;
      if (Microsoft && Microsoft.Maps && typeof Microsoft !== 'undefined') {
        const location = new Microsoft.Maps.Location(coordinates.Latitude, coordinates.Longitude);
        options = { maxResults: 3, countryCode: 'US', placeSuggestions: false, userLocation: location };
      }
    } else {
      options = { maxResults: 3, countryCode: 'US', placeSuggestions: false };
    }
    let manager;
    /* istanbul ignore if */
    if (Microsoft && Microsoft.Maps && typeof Microsoft !== 'undefined') {
      manager = new Microsoft.Maps.AutosuggestManager(options);
    }
    const input = '#previous_address1';
    const boxContainer = '#searchBoxContainer';
    /* istanbul ignore next */
    if (manager && document.querySelector(input) && document.querySelector(boxContainer)) {
      manager.attachAutosuggest(input, boxContainer, this.selectedSuggestionAddress.bind(this));
    } else {
      console.error('Elements for Bing AutoSugest not found');
    }
  }

  onErrorBingMaps(message) {
    console.log(message);
  }

  /* istanbul ignore next */
  selectedSuggestionAddress(suggestionResult) {
    this.previousResidenceInfoForm.get('PreviousAddress1').setValue(suggestionResult.address && suggestionResult.address.addressLine || '');
    this.previousResidenceInfoForm.get('PreviousCity').setValue(suggestionResult.address && suggestionResult.address.locality || '');
    this.previousResidenceInfoForm.get('PreviousState').setValue(this.getBingState(suggestionResult) || '');
    this.previousResidenceInfoForm.get('PreviousZipcode').setValue(suggestionResult.address && suggestionResult.address.postalCode || '');
    setTimeout(() => {
      // tslint:disable-next-line: max-line-length
      this.previousResidenceInfoForm.get('PreviousAddress1').setValue(suggestionResult.address && suggestionResult.address.addressLine || '');
    }, 1);
  }

  getBingState(suggestionResult: any) {
    let suggestedState: any;
    let state: string;
    if (suggestionResult && suggestionResult.address && this.states && suggestionResult.address.adminDistrict !== '') {
      suggestedState = this.states.filter(s => s.Details && s.Details.trim() === suggestionResult.address.adminDistrict.trim());
      state = suggestedState.length > 0 ? suggestedState[0].Value : '';
    }
    return state;
  }

  resetForm(form: UntypedFormGroup): any {
    form.reset();
    this.previousAddress1Cleared = true;
    this.previousAddress2Cleared = true;
    this.previousZipCodeCleared = true;
    this.previousCityCleared = true;
    this.formSubmitAttempt = false;
  }

  goNext() {
    let ca:any;
    this._formSubmitAttempt = true;
    this.previousAddress1Cleared = false;
    this.previousZipCodeCleared = false;
    this.previousCityCleared = false;
    getBackButton();
    if ((this.previousResidenceInfoForm.valid && this.previousResidenceInfoForm.dirty)
      || (this.previousResidenceInfoForm.valid && !this.formSubmitted)) {

        if (this.SitecoreConfig?.Sitecore?.isLegacyCreditApp) {
          ca = { ...this.creditAppService.LegacyCreditApplication };
        }else{
          ca = { ...this.creditAppService.CreditApplication };
        }

      const stepCount = (this.type === StepType.Buyer ? 3 : 9);
      /* istanbul ignore else */
      // if (ca.step <= stepCount || ca.step === 13) {
      ca.step = stepCount;
      // }

      ca[this.type].personalInformation.previousAddress = [{
        addressLine1: this.previousResidenceInfoForm.get('PreviousAddress1').value,
        addressLine2: this.previousResidenceInfoForm.get('PreviousAddress2').value,
        city: this.previousResidenceInfoForm.get('PreviousCity').value,
        monthsAtAddress: this.previousResidenceInfoForm.get('prevResidenceDurationGroup.PreviousMonthsAtAddress').value,
        postalCode: this.previousResidenceInfoForm.get('PreviousZipcode').value,
        stateCode: this.previousResidenceInfoForm.get('PreviousState').value,
        yearsAtAddress: this.previousResidenceInfoForm.get('prevResidenceDurationGroup.PreviousYearsAtAddress').value
      }];

      this.isSaving = true;
      this.creditAppService.SaveCreditApp(ca,this.SubPage).subscribe(response => {
        if (response.isSuccess) {
          this.isSaving = false;
          this.formSubmitted = true;
          this.previousResidenceInfoForm.markAsPristine();
          this.loadNextComponent();
        } else {
          this.isSaving = false;
          this.reportErrorResponse(response);
        }
      }, error => {
        this.isSaving = false;
        this.reportErrorResponse(error);
      });
    } else if (this.previousResidenceInfoForm.valid && this.formSubmitted) {
      this.loadNextComponent();
    }
  }

  reportErrorResponse(errorData: any) {
    const analyticsErrorResponse: IAnalyticsErrorResponse = {
      error: errorData.statusCode ? errorData.statusCode : UDOConstant.ErrorCode,
      error_message: errorData.message ? errorData.message : UDOConstant.ServiceUnavailable,
      error_type: ErrorType.CreditAppNotSaved
    };
    this.analyticsEventService.reportAnalyticsEvent(
      new ServerError(new StepComponent(PreviousResidenceInfoComponent,
        ComponentName.PreviousResidenceInfoComponent,
        ComponentGroup.ResidenceInfo, true, this.type),
        analyticsErrorResponse));
  }

  private loadNextComponent() {
    let nextComponent: IComponentDetails;
    if (this.type === StepType.Buyer) {
      nextComponent = {
        groupName: ComponentGroup.EmploymentInfo,
        component: new StepComponent(EmploymentInfoComponent,
          ComponentName.EmploymentInfoComponent, ComponentGroup.EmploymentInfo, true),
        componentName: ComponentName.EmploymentInfoComponent
      };

      this.analyticsEventService.reportAnalyticsEvent(
        new NextCTAClick(new StepComponent(PreviousResidenceInfoComponent,
          ComponentName.PreviousResidenceInfoComponent,
          ComponentGroup.ResidenceInfo, true, this.type))
      );
    } else {
      nextComponent = {
        groupName: ComponentGroup.CoBuyerEmployment,
        component: new StepComponent(EmploymentInfoComponent,
          ComponentName.CoBuyerEmploymentInfoComponent,
          ComponentGroup.CoBuyerEmployment, true, StepType.CoBuyer),
        componentName: ComponentName.CoBuyerEmploymentInfoComponent
      };

      this.analyticsEventService.reportAnalyticsEvent(
        new NextCTAClick(new StepComponent(PreviousResidenceInfoComponent,
          ComponentName.CoBuyerPreviousEmploymentInfoComponent,
          ComponentGroup.CoBuyerResidence, true, this.type))
      );
    }
    this.nextComponentService.loadComponent(nextComponent);
  }

  controlCleared(formControl) {
    switch (this.getControlName(formControl)) {
      case 'PreviousAddress1':
        this.previousAddress1Cleared = true;
        break;
      case 'PreviousAddress2':
        this.previousAddress2Cleared = true;
        break;
      case 'PreviousZipcode':
        this.previousZipCodeCleared = true;
        break;
      case 'PreviousCity':
        this.previousCityCleared = true;
        break;
      // tslint:disable-next-line: no-switch-case-fall-through
      default:
        break;
    }
  }

  clearValidations(formControl: AbstractControl) {
    if (formControl.invalid) {
      formControl.reset();
      this.controlCleared(formControl);
    }
  }

  getControlName(c: AbstractControl): string | null {
    const formGroup = c.parent && c.parent.controls;
    return formGroup ? Object.keys(formGroup).find(name => c === formGroup[name]) : null;
  }

  async getBrowserZipcode() {
    let zipcode; 
    try {
        const location = await (window as any).AN?.locationService?.getBrowserLocation();
        if (location?.ValidPostalCode) {
          zipcode = location.PostalCode;
        }
    }
    catch(error) {
      zipcode =  (window as any).AN?.locationService?.getLocation()?.zipCode || '';
    }

		if (zipcode) {
      this.previousResidenceInfoForm.get('PreviousZipcode').setValue(zipcode);
      this.cd.detectChanges();
		}

  }

  goBack() {
    let currentComponent: IComponentDetails;
    if (this.type === StepType.Buyer) {
      currentComponent = {
        groupName: ComponentGroup.ResidenceInfo,
        component: new StepComponent(PreviousResidenceInfoComponent,
          ComponentName.PreviousResidenceInfoComponent, ComponentGroup.ResidenceInfo, true),
        componentName: ComponentName.PreviousResidenceInfoComponent
      };
    } else {
      currentComponent = {
        groupName: ComponentGroup.CoBuyerResidence,
        component: new StepComponent(PreviousResidenceInfoComponent,
          ComponentName.CoBuyerPreviousResidenceInfoComponent, ComponentGroup.CoBuyerResidence, true, StepType.CoBuyer),
        componentName: ComponentName.CoBuyerPreviousResidenceInfoComponent
      };
    }
    this.previousComponentService.loadComponent(currentComponent);
  }

  @HostListener('window:AzureMapsZipUpdate', ['$event'])
  onAzureMapsZipUpdate(event) {
    /* istanbul ignore next */
    if (event && event.detail && document.getElementById('previous_address1') !==null) {
      this.previousResidenceInfoForm.get('PreviousAddress1').setValue(event.detail.address);
      this.previousResidenceInfoForm.get('PreviousCity').setValue(event.detail.city);
      this.previousResidenceInfoForm.get('PreviousState').setValue(event.detail.state);
      this.previousResidenceInfoForm.get('PreviousZipcode').setValue(event.detail.zip);
    }
  }

  updateCtas() {
    try {
      (window as any).standalonePrequal.updateCtasPosition();
    } catch (error) {/* istanbul ignore next */
      console.log(error);
    }
  }

  isMobile() {
    return window.innerWidth < 767 || (window.innerWidth > 768 && window.innerHeight < 480);
  }

  @HostListener('window:resize', ['$event'])
  reSize(e) {
    /* istanbul ignore next */
   this.isMobile();
  }
}


